'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _IconConstants = require('../icon/IconConstants');

var _iconName = require('../utils/propTypes/iconName');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SIZE_CLASSES = {
  small: 'private-drop-zone--small',
  large: 'private-drop-zone--large'
};

var USE_CLASSES = {
  default: '',
  hover: 'private-drop-zone--hover',
  processing: 'private-drop-zone--processing',
  selected: 'private-drop-zone--selected',
  error: 'private-drop-zone--error',
  success: 'private-drop-zone--success'
};

var ICON_SIZES_FOR_DROP_SIZE = {
  small: 'xs',
  large: 'sm'
};

var UIDropZone = _react2.default.createClass({
  displayName: 'UIDropZone',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    contentClassName: _react.PropTypes.string,
    iconName: (0, _iconName.getIconNamePropType)(),
    iconSize: _react.PropTypes.oneOf(Object.keys(_IconConstants.ICON_SIZES)),
    size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: 'small',
      use: 'default'
    };
  },
  renderImage: function renderImage(_ref) {
    var size = _ref.size,
        iconSize = _ref.iconSize,
        iconName = _ref.iconName;

    if (iconName) {
      var actualIconSize = iconSize || ICON_SIZES_FOR_DROP_SIZE[size];
      return _react2.default.createElement(_UIIcon2.default, {
        name: iconName,
        className: 'private-drop-zone__icon',
        size: actualIconSize
      });
    }

    return null;
  },
  renderContent: function renderContent(_ref2, _ref3) {
    var children = _ref2.children,
        contentClassName = _ref2.contentClassName;
    var renderedImage = _ref3.renderedImage;

    return _react2.default.createElement(
      'div',
      {
        className: (0, _reactUtils.classNames)('private-drop-zone__content', contentClassName)
      },
      renderedImage,
      _react2.default.createElement(
        'div',
        { className: 'private-drop-zone__body' },
        children
      )
    );
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        contentClassName = _props.contentClassName,
        iconName = _props.iconName,
        iconSize = _props.iconSize,
        size = _props.size,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'contentClassName', 'iconName', 'iconSize', 'size', 'use']);

    var computedClassName = (0, _reactUtils.classNames)('private-drop-zone', SIZE_CLASSES[size], USE_CLASSES[use], className);
    var renderedImage = this.renderImage({ size: size, iconSize: iconSize, iconName: iconName });
    var renderedContent = this.renderContent({ children: children, contentClassName: contentClassName }, { renderedImage: renderedImage });

    return _react2.default.createElement(
      _UISection2.default,
      _extends({}, rest, { className: computedClassName }),
      renderedContent
    );
  }
});

exports.default = UIDropZone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/drop/UIDropZone.js
// module id = 341
// module chunks = 0